import Icon from "@ant-design/icons";

const Svg = () => {
  return (
    <svg width="100%" height="100%" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 8V7M16 8C13.049 8 10.6667 10.3241 10.6667 13.3C10.6667 19.6 8 22 8 22H24C24 22 21.3333 19.6 21.3333 13.3C21.3333 10.3241 18.951 8 16 8ZM17 24C16.8678 24.4005 16.4828 25 16 25C15.5172 25 15.1322 24.4005 15 24" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  )
}
export const MyIcon = (props: any) => <Icon component={Svg} {...props} />;